import type { GridColDef } from '@mui/x-data-grid';

import HoverCopyCell from '@/components/table-data-grid/HoverCopyCell';
import { dateUtils } from '@/utils/date';

export const columns = (): GridColDef[] => [
    {
        field: 'code',
        headerName: 'Mã định danh',
        editable: false,
        sortable: false,
        minWidth: 200,
        flex: 1,
        renderCell: params => <HoverCopyCell value={params.value} />,
    },
    {
        field: 'name',
        headerName: 'Tên loại thiết bị',
        editable: false,
        sortable: false,
        minWidth: 200,
        flex: 1,
        renderCell: params => <HoverCopyCell value={params.value} />,
    },
    {
        field: 'createdDate',
        headerName: 'Ngày tạo',
        editable: false,
        sortable: true,
        flex: 1,
        minWidth: 150,
        sortingOrder: ['asc', 'desc'],
        renderCell: params => (
            <HoverCopyCell value={dateUtils.getDate(params.value)} />
        ),
    },
    {
        field: 'description',
        headerName: 'Mô tả',
        editable: false,
        sortable: false,
        minWidth: 300,
        flex: 1,
        renderCell: params => <HoverCopyCell value={params.value} />,
    },
];
